import { type PropsWithChildren } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationFloatingBar = (props: PropsWithChildren) => {
  const { bottom } = useSafeAreaInsets();

  const safeAreaStyle = useStyle(() => {
    const bottomOffset = Platform.select({
      android: theme.spacing['4'],
      default: 0,
    });

    return { bottom: Math.max(bottom, theme.spacing['4']) + bottomOffset };
  }, [bottom]);

  return (
    <View
      style={[styles.floatingWrapper, safeAreaStyle]}
      pointerEvents="box-none"
    >
      {props.children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  floatingWrapper: {
    position: 'absolute',
    right: 0,
    left: 0,
    gap: theme.spacing['4'],
    marginHorizontal: theme.spacing['4'],
  },
});
